<template>
  <div class="shadow-[0_1px_6px_rgb(0,0,0,0.01)] p-4 w-full md:rounded-md md:border bg-white">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'SlotWrapper'
}
</script>

<style scoped>
</style>
